import React, { useEffect, useState} from "react";
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import BigNumber from "bignumber.js";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import { useSnackbar } from 'notistack';
import Countdown from 'react-countdown';

const RefundTokens = ({ accounts, sales, onConnect, readSales, config  }) => {
  const [refundeeAddress, setRefundeeAddress] = useState("")
  const [fromAddress, setFromAddress] = useState("")
  const [processing, setProcessing] = useState(false)
  const { enqueueSnackbar } = useSnackbar();
  const [address, setAddress] = useState()

  const setState = async () => {
    if (accounts && refundeeAddress == "") {
      setRefundeeAddress(accounts[0])
      setFromAddress(accounts[0])
    }
    if (readSales && address != readSales._address) {
      setAddress(readSales._address);
    }
  }

  const onRefund = async () => {
    setProcessing(true)
    try {
      const finalized = await readSales.methods.finalized().call()
      if (!finalized) {
        enqueueSnackbar("not finalized", { variant: 'error' })
        setProcessing(false)
        return
      }
      const goalReached = await readSales.methods.goalReached().call()
      if (goalReached) {
        enqueueSnackbar("goal reached", { variant: 'error' })
        setProcessing(false)
        return
      }
      await sales.methods.claimRefund(
        refundeeAddress
      ).send({
        from: accounts[0]
      })
      setProcessing(false)
    } catch (e) {
      setProcessing(false)
    }
  }
  useEffect(() => {
    setState()
  })

  return (
    <Container>
      <Typography component="h1" variant="h5">
        Refund BNB
      </Typography>
      <Grid container spacing={2}>
        {/* <Grid item xs={12} sm={6}>
          <Container className="MuiOutlinedInput-input">
            <FormattedMessage id="App.RefundTokens.FromAddress" />
          </Container>
        </Grid>
        <Grid item xs={12} sm={6}>
          {fromAddress}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Container className="MuiOutlinedInput-input">
            <FormattedMessage id="App.RefundTokens.RefundeeAddress" />
          </Container>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField variant="outlined" onChange={(e) => setRefundeeAddress(e.target.value)} value={refundeeAddress} fullWidth={true} />
        </Grid>
        <Grid container justify={'flex-end'}>
          {sales ?
            <Button variant="contained" color="primary" onClick={onRefund} disabled={processing}>
              <FormattedMessage id="App.RefundTokens.Refund" />
            </Button> :
            <Button variant="contained" color="primary" onClick={onConnect}>
              <FormattedMessage id="App.Root.Connect" />
            </Button>
          }
        </Grid> */}
        <Grid container justify={'flex-end'}>
          <p align="right" style={{ padding: "0 18.5px", margin: 0, fontSize: "0.75rem", width: "100%" }}>
            {fromAddress}
          </p>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Container className="MuiOutlinedInput-input">
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              STEP1:
            </Typography>
          </Container>
        </Grid>
        <Grid item xs={11} sm={8}>
          <Container className="MuiOutlinedInput-input" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <Button style={{ width: "100%" }} variant="contained" color="primary" onClick={onConnect} disabled={sales != undefined}>
              Connect Wallet
            </Button>
          </Container>
        </Grid>
        <Grid container justify={'flex-end'}>
          <Link href="#" style={{ padding: "0 18.5px", margin: 0, fontSize: "1.15rem" }} color="inherit">
            Click here to buy with your <p style={{ display: "inline", color: "#e07000" }}>smartphone &gt;</p>
          </Link>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Container className="MuiOutlinedInput-input">
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              STEP2:
            </Typography>
          </Container>
        </Grid>
        <Grid item xs={11} sm={8}>
          <Container className="MuiOutlinedInput-input" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <Button style={{ width: "100%" }} variant="contained" color="primary" onClick={onRefund} disabled={processing || sales == undefined}>
              Refund EAR(confirm)
            </Button>
          </Container>
        </Grid>
        <Grid container>
          <p style={{ padding: "0 18.5px", margin: 0, fontSize: "0.95rem" }}>
            *After refund BNB, click this Adress to see your transacion.<br />
          </p>
          <p style={{ padding: "0 18.5px", margin: 0, fontSize: "0.75rem", width: "100%" }}>
            SalesContractAddress:
          </p><br />
          <p style={{ padding: "0 18.5px", margin: 0, fontSize: "0.75rem", width: "100%" }}>
            {address !== undefined &&
              <Link href={config.etherscan.getAddressUrl(address)} target="_blank">
                {address}
              </Link>
            }
          </p>
        </Grid>
      </Grid>
    </Container>
  );
}
export default RefundTokens;
